<!-- <div class="dependecies-container"> -->
<ng-container *ngIf="!isDense">
    <header>
        <h2>
            {{ 'mapping.base.dependencies.title.fullLabel' | translate: {label: label} }}
        </h2>
        <section class="info">
            <mat-icon>help</mat-icon>
            <p>
                {{ 'mapping.base.dependencies.title.summary' | translate: {label: label} }}
            </p>
        </section>
    </header>

    <ng-container *ngIf="dependencies && dependencies.length">
        <form [formGroup]="filterForm"
              class="filter-form">
            <mat-form-field>
                <mat-label>{{ 'mapping.base.dependencies.filter.shortLabel' | translate: {label: label} }}</mat-label>
                <input matInput
                       type="text"
                       formControlName="filter">
            </mat-form-field>
            <div class="select-all"
                 *ngIf="canEditMapping">
                <mat-checkbox formControlName="selectAll"
                              labelPosition="before">
                    {{ 'mapping.base.dependencies.selectAll.shortLabel' | translate }}
                </mat-checkbox>
                ({{ selDependencies.length }})
            </div>
        </form>
    </ng-container>
</ng-container>

<section class="tree-form"
         *ngIf="editedItem">
    <app-edit-form [item]="editedItem"
                   (valueSubmitted)="onEditFinished($event)"></app-edit-form>
</section>

<section class="dependencies-list"
         *ngIf="!editedItem">
    <mat-list [class.fit]="!isDense"
              (drop)="onDrop($event)"
              (dragover)="allowDrop($event)">
        <mat-list-item *ngFor="let item of filteredDependencies | mappingDisplayOrder: pipeCounter; index as i"
                       [ngClass]="{selected: isSelected(item.id)}">
            <span mat-line
                  class="label"
                  [class.no-drag]="!canEditMapping"
                  draggable="true"
                  [draggable]="canEditMapping"
                  (dragstart)="onDrag($event, item)">
                {{ item.text ? item.text.fullLabel : item.code }}
                <span *ngIf="item.type"> - {{ item.type }}</span>
                <app-tooltip [text]="item.text ? item.text.detail : item.description"></app-tooltip>
            </span>

            <button mat-icon-button
                    *ngIf="!isDense && canEditMapping"
                    [matTooltip]="'mapping.base.dependencies.select.fullLabel' | translate: {label: label}"
                    (click)="onSelect(item.id)">
                <mat-icon aria-label="checkbox" [ngClass]="isSelected(item.id) ? 'selected' : 'not-selected'">
                    {{ isSelected(item.id) ? 'check_box' : 'check_box_outline_blank'}}
                </mat-icon>
            </button>
            <button mat-icon-button
                    color="accent"
                    [matTooltip]="'mapping.base.tree.edit.fullLabel' | translate"
                    (click)="onEditStarted(item)"
                    *ngIf="canEditDependencies">
                <mat-icon aria-label="Add">create</mat-icon>
            </button>
            <ng-container *ngIf="isDense">
                <div class="buttonsMove-group">

                    <button mat-icon-button
                            color="accent"
                            [disabled]="item.displayOrder === 0"
                            (click)="moveUp(i)"
                            *ngIf="canEditMapping">
                        <mat-icon aria-label="move up">expand_less</mat-icon>
                    </button>
                    <button mat-icon-button
                            color="accent"
                            [disabled]="item.displayOrder === filteredDependencies.length - 1"
                            (click)="moveDown(i)"
                            *ngIf="canEditMapping">
                        <mat-icon aria-label="move down">expand_more</mat-icon>
                    </button>
                </div>
            </ng-container>
        </mat-list-item>
        <mat-list-item class="empty"
                       *ngIf="!dependencies.length">
            {{'mapping.base.dependencies.empty.summary' | translate}}
        </mat-list-item>
    </mat-list>
</section>
<!-- </div> -->